import React, { forwardRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import withStyle from './Iframe.style.js'

const contentStyle = (className) =>
  `.app-header, .app-page-meta, .app-footer, .${className} { display: none !important; }`

const Iframe = forwardRef((props, ref) => {
  const { classNameToStyle } = props
  const onIframeRef = useCallback(() => {
    const iframe = ref.current

    const interval = setInterval(() => {
      const { head } = iframe.contentDocument
      if (head !== null) {
        const style = iframe.contentDocument.createElement('style')
        style.textContent = contentStyle(classNameToStyle)
        head.appendChild(style)

        clearInterval(interval)
      }
    }, 400)

    return interval
  }, [classNameToStyle, ref])

  useEffect(() => {
    let interval = null

    if (ref.current) {
      interval = onIframeRef()
    }

    return () => clearInterval(interval)
  }, [ref, onIframeRef])

  return (
    <iframe
      ref={ref}
      {...props}
      title={'chec_iframe'}
      sandbox="allow-same-origin allow-scripts"
      style={{ display: 'block' }}
    />
  )
})

Iframe.propTypes = {
  /** title */
  title: PropTypes.string,
  /** The URL of the page to embed */
  src: PropTypes.string,
  /** The width of the frame in CSS pixels. Default is 300 */
  width: PropTypes.string,
  /** The height of the frame in CSS pixels. Default is 150. */
  height: PropTypes.string,
  /** handler to control iframe content node styles */
  onIframeRef: PropTypes.func,
  /** 0 for no border, 1 for border */
  frameBorder: PropTypes.oneOf(['0', '1']),
  /** id for manipulating iframe element */
  id: PropTypes.string,
  /** element to style in iframe content document */
  classNameToStyle: PropTypes.string,
  /** element to style in iframe content document */
  allowFullScreen: PropTypes.bool,
}

export default withStyle(Iframe)
